import { NotificationRuleBaseDto } from './notification-rule-base-dto';

export class NotificationRuleWorkItemDto extends NotificationRuleBaseDto {
  id: string;
  clientIds: number[];
  processNodeIds: string[];
  statuses: number[];
}
